import API from "../base.service";
import { ENDPOINT } from "../../constants.service";

const createCompany = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.companies.create}`,
    true,
    data,
    true
  );
};
const createCompanyAttachment = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.companies.createAttachment}`,
    true,
    data,
    true
  );
};
const updateCompany = async (data, json) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.companies.update}`,
    true,
    data,
    json ? false : true
  );
};
const companiesList = async (data) => {
  return await API.getMethod(
    `${ENDPOINT.peoples.companies.list}`,
    true,
    true,
    data
  );
};
const deleteCompany = async (id) => {
  const url = `${ENDPOINT.peoples.companies.delete}`.replace(":id", id);
  return await API.deleteMethod(url, true);
};
const deletAttachment = async (id) => {
  const url = `${ENDPOINT.peoples.companies.deleteAttachment}`.replace(
    ":id",
    id
  );
  return await API.getMethod(url, true);
};
const getCompany = async (id) => {
  const url = `${ENDPOINT.peoples.companies.show}`.replace(":id", id);
  return await API.getMethod(url, true);
};

const createCompanyAccount = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.companies.companyAccount.create}`,
    true,
    data,
    true
  );
};
const updateCompanyAccount = async (data, id) => {
  const url = `${ENDPOINT.peoples.companies.companyAccount.update}`.replace(
    ":id",
    id
  );
  return await API.putMethod(url, true, data);
};

const getCompanyAccount = async (id) => {
  const url = `${ENDPOINT.peoples.companies.companyAccount.show}`.replace(
    ":id",
    id
  );
  return await API.getMethod(url, true);
};
const deleteCompanyAccount = async (id) => {
  const url = `${ENDPOINT.peoples.companies.companyAccount.delete}`.replace(":id", id);
  return await API.deleteMethod(url, true);
};


export default {
  getCompany,
  createCompany,
  updateCompany,
  companiesList,
  deleteCompany,
  deletAttachment,
  createCompanyAttachment,

  /** company account routes */
  createCompanyAccount,
  updateCompanyAccount,
  getCompanyAccount,
  deleteCompanyAccount,
};
